import { getBumblebeeMessages } from "../../../../../../../../../shared/api/bumblebee/bumblebee";
import type { ISessionData } from "../../../../../../../../../shared/types/session.type";

export async function fetchBumblebeeSessionData(
	sessionId: string,
): Promise<ISessionData | null> {
	const response = await getBumblebeeMessages(sessionId);
	const payload = response.data;
	if (!payload?.success) return null;

	return {
		ok: true,
		type: "session.switch_success",
		session_id: payload.session_id,
		previous_session_id: "",
		count: payload.count,
		messages: payload.messages.map((message) => ({
			role: message.role,
			content: message.content,
			ts: message.ts,
			type: message.type,
			meta: {
				event: message.type,
				customer_id: String(message.meta?.campaign_id ?? ""),
				campaign_id: String(message.meta?.campaign_id ?? ""),
				...(message.meta?.campaign_name
					? {
							campaign_name: String(message.meta.campaign_name).trim(),
						}
					: {}),
			},
		})),
	};
}
